// iConnect — News archive topics and load more (archive-news.php)
// Replaces _news-filter.js.
//
// A topic chip slides the lime marker across to it (GSAP Flip), fades the
// current cards out while the server sends that topic's first page
// (action filter_news, inc/news-archive.php), then staggers the new cards in.
// Load more appends the next page of the same topic.

import gsap from "../gsap/gsap.min.js";
import { Flip } from "../gsap/Flip.min.js";

gsap.registerPlugin(Flip);

(function () {

const grid = document.querySelector("#news-grid");
if (!grid) return;

const chips   = [...document.querySelectorAll(".news-filter__chip")];
const marker  = document.querySelector(".news-filter__marker");
const loadBtn = document.querySelector("#news-load-more");
const count   = document.querySelector("#news-count");
const empty   = document.querySelector("#news-empty");

let term = "0";
let page = 1;
let busy = false;

async function request() {
    const fd = new FormData();
    fd.append("action", "filter_news");
    fd.append("nonce", window.newsAjax.nonce);
    fd.append("term", term);
    fd.append("paged", page);

    const res = await fetch(window.newsAjax.ajax_url, { method: "POST", body: fd });
    if (!res.ok) throw new Error("filter_news failed: " + res.status);
    return res.json();
}

function render(data, append) {
    const tmp = document.createElement("div");
    tmp.innerHTML = data.html;
    const incoming = [...tmp.children];

    if (!append) grid.replaceChildren();
    grid.append(...incoming);

    gsap.from(incoming, {
        opacity: 0,
        y: 30,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.06
    });

    count.textContent = data.found;
    empty.hidden = data.found > 0;
    loadBtn.hidden = page >= data.max_pages;
}

async function selectTopic(chip) {
    if (busy || chip.dataset.term === term) return;
    busy = true;

    // Marker slides from the old chip to the new one.
    const state = Flip.getState(marker);
    chip.append(marker);
    Flip.from(state, { duration: 0.5, ease: "power3.inOut" });

    chips.forEach(el => el.setAttribute("aria-pressed", el === chip));

    term = chip.dataset.term;
    page = 1;

    grid.setAttribute("aria-busy", "true");
    const [data] = await Promise.all([
        request(),
        gsap.to(grid.children, { opacity: 0, y: 16, duration: 0.25, stagger: 0.02 })
    ]);
    render(data, false);
    grid.removeAttribute("aria-busy");

    busy = false;
}

async function loadMore() {
    if (busy) return;
    busy = true;

    page++;
    render(await request(), true);

    busy = false;
}

chips.forEach(chip => chip.addEventListener("click", () => selectTopic(chip)));
loadBtn.addEventListener("click", loadMore);

})();
